import { render, staticRenderFns } from "./SplideCarouselThumb.vue?vue&type=template&id=449a6397"
import script from "./SplideCarouselThumb.vue?vue&type=script&lang=js"
export * from "./SplideCarouselThumb.vue?vue&type=script&lang=js"
import style0 from "./SplideCarouselThumb.vue?vue&type=style&index=0&id=449a6397&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports